'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Section(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['center'];
  var sectionModifiers = defaultModifiers.concat(modifiers);

  return _react2.default.createElement(_styledComponentsReactiveGrid.Row, _extends({ modifiers: sectionModifiers }, rest));
}

Section.defaultProps = {
  modifiers: []
};

Section.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Section;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/MessageLarge/Section.js
// module id = 1566
// module chunks = 2